var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-toggle"},[_c('checkbox-toggle',{attrs:{"label":'Full Width',"value":_vm.isFullWidth},on:{"input":_vm.onLayoutChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }